import ImgNotFound from '../../assets/imgs/pagina_nao_encontrada.svg';
import { Typography } from '../../components/tailwind';

const classes = {
    image: {
        marginTop: 300,
        display: 'inline-block',
        maxWidth: '100%',
        width: 860,
    },
};

const NotFound = () => {
    return (
        <div
            style={{
                paddingTop: 80,
                textAlign: 'center',
                width: '100%',
            }}
        >
            <div className='w-full flex flex-col items-center'>
                <div className='w-full'>
                    <Typography variant="h1">404: A página informada não foi encontrada</Typography>
                    <Typography variant="h5"><a href="/">Voltar ao início</a></Typography>
                </div>

                <img
                    style={{ marginTop: 120 }}
                    alt="Under development"
                    className={classes.image}
                    src={ImgNotFound}
                />
            </div>
        </div>
    );
};

export default NotFound;